import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

export default function AddRetailerButton({ prospect, edit, getRetailers }) {
  const navigate = useNavigate();
  return (
    <Button
      onClick={(e) => {
        e.preventDefault();
        document.getElementById('submit-add-new-retailer').click();
        //navigate('/my-customer');
      }}
      variant='contained'
    >
      {prospect
        ? 'Save And Send Email'
        : edit
        ? 'Save Changes'
        : 'Add New Retailer'}
    </Button>
  );
}

AddRetailerButton.propTypes = {
  prospect: PropTypes.bool.isRequired,
  edit: PropTypes.bool.isRequired,
  getRetailers: PropTypes.func.isRequired,
};
